// ==================== FILE: src/components/BlogPost/index.js ====================
import React from 'react';

const BlogPost = ({ post }) => {
    return (
        <div className="wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s">
            <div className="col-md-6 col-sm-6">
                <div className="blog-block">
                    <div className="blog-img-box">
                        <img src={post.image || post.imageSrc} alt="" />
                        <div className="overlay">
                            <a href="#"><i className="fa fa-link" aria-hidden="true"></i></a>
                        </div>
                    </div>
                    <div className="blog-dit">
                        <p><span>{post.date}</span></p>
                        <h2>{post.title}</h2>
                        <h5>BY {post.author}</h5>
                    </div>
                </div>
            </div>
            {/* end col */}
        </div>
    );
};

export default BlogPost;